import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksOutlineButton, {
  Sizing,
} from '../../books/common/buttons/BooksOutlineButton';
import BooksMenu from '../../books/model1/BooksMenu';
import css from './BooksSelectedStaff.module.scss';

interface Props {
  className?: string;
  changeStaff: () => void;
  id: string | number;
  name: string;
  withBorderBottom?: boolean;
  withBorderTop?: boolean;
  withPaddingLarge?: boolean;
}

const BooksSelectedStaff = ({
  className,
  intl,
  name,
  changeStaff,
  withBorderBottom,
  withBorderTop,
  withPaddingLarge,
}: Props & InjectedIntlProps) => {
  const classes = classNames(
    css.BooksSelectedStaff,
    {
      [css.withBorderTop]: withBorderTop,
      [css.withBorderBottom]: withBorderBottom,
      [css.withPaddingLarge]: withPaddingLarge,
    },
    className,
  );

  return (
    <div className={classes}>
      <BooksMenu menuName={name} />
      <BooksOutlineButton
        className={css.BooksSelectedStaff__Button}
        sizing={Sizing.Small}
        children={intl.formatMessage({ id: 'books.button.change' })}
        onClick={changeStaff}
      />
    </div>
  );
};

export default injectIntl(BooksSelectedStaff);
